module.exports = __webpack_public_path__ + "img/kefu@2x.598b33c0.png";